<script setup lang="ts">
import type { InputHTMLAttributes } from 'vue';
import type { BaseTextInputProps } from './internal';
import NxInput from './NxInput.vue';

defineProps<BaseTextInputProps & /* @vue-ignore */ Omit<InputHTMLAttributes, 'value'>>();

const [valueModel, valueModelModifiers] = defineModel<string, 'lazy'>({ required: true });
</script>
<template>
  <NxInput
    v-if="valueModelModifiers.lazy"
    :id="$props.id"
    v-model.lazy="valueModel"
    type="password"
    :icons="$props.icons"
    :wrapper-style="$props.wrapperStyle"
    :height="$props.height"
  />
  <NxInput
    v-else
    :id="$props.id"
    v-model="valueModel"
    type="password"
    :icons="$props.icons"
    :wrapper-style="$props.wrapperStyle"
    :height="$props.height"
  />
</template>
